import _classCallCheck from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _get from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { Remediator } from './Remediator.js';
import { getAuthenticatorFromRemediation } from '../util.js';
import { isAuthenticator } from '../../types/api.js';
import { findMatchedOption, compareAuthenticators } from '../../authenticator/util.js';
var SelectAuthenticator = /*#__PURE__*/function (_Remediator) {
  function SelectAuthenticator() {
    _classCallCheck(this, SelectAuthenticator);
    return _callSuper(this, SelectAuthenticator, arguments);
  }
  _inherits(SelectAuthenticator, _Remediator);
  return _createClass(SelectAuthenticator, [{
    key: "findMatchedOption",
    value: function findMatchedOption(authenticators, options) {
      var option;
      var _iterator = _createForOfIteratorHelper(authenticators),
        _step;
      try {
        var _loop = function _loop() {
          var authenticator = _step.value;
          option = options.find(function (_ref) {
            var relatesTo = _ref.relatesTo;
            return relatesTo.key && relatesTo.key === authenticator.key;
          });
          if (option) {
            return 1; // break
          }
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          if (_loop()) break;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return option;
    }
  }, {
    key: "canRemediate",
    value: function canRemediate(context) {
      var _a, _b;
      var _this$values = this.values,
        authenticators = _this$values.authenticators,
        authenticator = _this$values.authenticator;
      var authenticatorFromRemediation = getAuthenticatorFromRemediation(this.remediation);
      var options = authenticatorFromRemediation.options;
      if (!authenticators || !authenticators.length) {
        return false;
      }
      if (isAuthenticator(authenticator) && authenticator.id) {
        return true;
      }
      var matchedOption = this.findMatchedOption(authenticators, options);
      if (matchedOption) {
        var isCurrentAuthenticator = (context === null || context === void 0 ? void 0 : context.currentAuthenticator) && (context === null || context === void 0 ? void 0 : context.currentAuthenticator.value.id) === ((_a = matchedOption.relatesTo) === null || _a === void 0 ? void 0 : _a.id);
        var isCurrentAuthenticatorEnrollment = (context === null || context === void 0 ? void 0 : context.currentAuthenticatorEnrollment) && (context === null || context === void 0 ? void 0 : context.currentAuthenticatorEnrollment.value.id) === ((_b = matchedOption.relatesTo) === null || _b === void 0 ? void 0 : _b.id);
        return !isCurrentAuthenticator && !isCurrentAuthenticatorEnrollment;
      }
      return false;
    }
  }, {
    key: "mapAuthenticator",
    value: function mapAuthenticator(remediationValue) {
      var _this$values2 = this.values,
        authenticators = _this$values2.authenticators,
        authenticator = _this$values2.authenticator;
      if (isAuthenticator(authenticator) && authenticator.id) {
        this.selectedAuthenticator = authenticator;
        return authenticator;
      }
      var options = remediationValue.options;
      var selectedOption = findMatchedOption(authenticators, options);
      this.selectedAuthenticator = selectedOption.relatesTo;
      this.selectedOption = selectedOption;
      return {
        id: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value.form.value.find(function (_ref2) {
          var name = _ref2.name;
          return name === 'id';
        }).value
      };
    }
  }, {
    key: "getInputAuthenticator",
    value: function getInputAuthenticator(remediation) {
      var options = remediation.options.map(function (_ref3) {
        var label = _ref3.label,
          relatesTo = _ref3.relatesTo;
        return {
          label: label,
          value: relatesTo.key
        };
      });
      return {
        name: 'authenticator',
        type: 'string',
        options: options
      };
    }
  }, {
    key: "getValuesAfterProceed",
    value: function getValuesAfterProceed() {
      var _this = this;
      this.values = _superPropGet(SelectAuthenticator, "getValuesAfterProceed", this, 3)([]);
      var authenticators = this.values.authenticators.filter(function (authenticator) {
        return compareAuthenticators(authenticator, _this.selectedAuthenticator) !== true;
      });
      return Object.assign(Object.assign({}, this.values), {
        authenticators: authenticators
      });
    }
  }]);
}(Remediator);
export { SelectAuthenticator };